export default "__VITE_ASSET__DyBnR_n6__"